var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { observable, computed, action, makeObservable } from 'mobx';
import { Message } from '../../store/message/message';
import { messageService } from '../../store/singleton';
import { ErrorType } from '../../store/error/error';
import * as dateFormat from '../../common/date-format';
var MessageStore = (function () {
    function MessageStore(messageStore) {
        Object.defineProperty(this, "messages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "peopleInChatStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fileSizeLimit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fileExtensions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "file", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fileError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isSending", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeObservable(this);
        this.messages = messageStore.messages || [];
        this.peopleInChatStore = messageStore.peopleInChatStore || {};
        this.fileSizeLimit = messageStore.fileSizeLimit || 1024;
        this.fileExtensions = messageStore.fileExtensions || [];
        this.file = messageStore.file || null;
        this.fileError = messageStore.fileError;
        this.isLoading = this.isLoading || false;
        this.isSending = this.isSending || false;
    }
    Object.defineProperty(MessageStore.prototype, "lastMessageId", {
        get: function () {
            var messageIds = this.messages.map(function (message) { return message.messageId; });
            return Math.max.apply(Math, messageIds);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MessageStore.prototype, "hasAttachment", {
        get: function () {
            return this.file != null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MessageStore.prototype, "hasFileError", {
        get: function () {
            return this.fileError != null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MessageStore.prototype, "getMessages", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (masterAccountId, userId, entityType, entityId) {
            return __awaiter(this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = this;
                            return [4, messageService.getMessages(masterAccountId, entityType, entityId)];
                        case 1:
                            _a.messages = _b.sent();
                            return [2];
                    }
                });
            });
        }
    });
    Object.defineProperty(MessageStore.prototype, "sendMessage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (masterAccountId, userId, entityType, entityId, message) {
            return __awaiter(this, void 0, void 0, function () {
                var messageId;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.isSending = true;
                            this.messages.push(new Message({
                                messageId: -1,
                                message: message,
                                userId: userId,
                                userName: '',
                                displayInitial: '',
                                dateCreated: dateFormat.getUtcDateString(new Date()),
                                blobId: null,
                                filename: '',
                                isBeingSent: true
                            }));
                            return [4, messageService
                                    .sendMessage(masterAccountId, entityType, entityId, message, this.hasAttachment)];
                        case 1:
                            messageId = _a.sent();
                            if (!this.hasAttachment) return [3, 3];
                            return [4, this.uploadFile(masterAccountId, messageId)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            this.isSending = false;
                            return [2, messageId];
                    }
                });
            });
        }
    });
    Object.defineProperty(MessageStore.prototype, "selectFile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (file) {
            this.clearFileError();
            this.file = file;
        }
    });
    Object.defineProperty(MessageStore.prototype, "deleteFile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.clearFileError();
            this.file = null;
        }
    });
    Object.defineProperty(MessageStore.prototype, "validateFileExtension", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var isValid = !!this.file
                && this.fileExtensions
                    .some(function (fileExtension) { return !!_this.file && _this.file.name.endsWith(fileExtension); });
            if (isValid === false) {
                this.setFileError(this.getErrorTitle, ['Unsupported File Type. Please upload a different file.'], ErrorType.FileUpload);
            }
            return isValid;
        }
    });
    Object.defineProperty(MessageStore.prototype, "validateFileSize", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var isValid = !!this.file && this.file.size <= this.fileSizeLimit;
            if (isValid === false) {
                this.setFileError(this.getErrorTitle, ['Size limit exceeded. Please upload a different file.'], ErrorType.FileUpload);
            }
            return isValid;
        }
    });
    Object.defineProperty(MessageStore.prototype, "validateFile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return this.validateFileSize() && this.validateFileExtension();
        }
    });
    Object.defineProperty(MessageStore.prototype, "uploadFile", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (masterAccountId, messageId) {
            return __awaiter(this, void 0, void 0, function () {
                var response_1, _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!this.file) {
                                return [2];
                            }
                            this.isSending = true;
                            _c.label = 1;
                        case 1:
                            _c.trys.push([1, 3, , 5]);
                            return [4, messageService.uploadFile(masterAccountId, messageId, this.file)];
                        case 2:
                            _c.sent();
                            this.deleteFile();
                            return [3, 5];
                        case 3:
                            response_1 = _c.sent();
                            _a = this.setFileError;
                            _b = [this.getErrorTitle];
                            return [4, response_1.json()];
                        case 4:
                            _a.apply(this, _b.concat([_c.sent(), ErrorType.FileUpload]));
                            return [3, 5];
                        case 5:
                            this.isSending = false;
                            return [2];
                    }
                });
            });
        }
    });
    Object.defineProperty(MessageStore.prototype, "setLastReadMessage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (masterAccountId, entityType, entityId, messageId) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, messageService.setLastReadMessage(masterAccountId, entityType, entityId, messageId)];
                        case 1:
                            _a.sent();
                            return [2];
                    }
                });
            });
        }
    });
    Object.defineProperty(MessageStore.prototype, "setFileError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (filename, errorMessages, errorType) {
            this.fileError = {
                errorType: errorType,
                filename: filename,
                errorMessages: errorMessages
            };
        }
    });
    Object.defineProperty(MessageStore.prototype, "clearFileError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.fileError = null;
        }
    });
    Object.defineProperty(MessageStore.prototype, "getErrorTitle", {
        get: function () {
            return this.file ? this.file.name : '';
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        observable
    ], MessageStore.prototype, "messages", void 0);
    __decorate([
        observable
    ], MessageStore.prototype, "peopleInChatStore", void 0);
    __decorate([
        observable
    ], MessageStore.prototype, "fileSizeLimit", void 0);
    __decorate([
        observable
    ], MessageStore.prototype, "fileExtensions", void 0);
    __decorate([
        observable
    ], MessageStore.prototype, "file", void 0);
    __decorate([
        observable
    ], MessageStore.prototype, "fileError", void 0);
    __decorate([
        observable
    ], MessageStore.prototype, "isLoading", void 0);
    __decorate([
        observable
    ], MessageStore.prototype, "isSending", void 0);
    __decorate([
        computed
    ], MessageStore.prototype, "lastMessageId", null);
    __decorate([
        computed
    ], MessageStore.prototype, "hasAttachment", null);
    __decorate([
        computed
    ], MessageStore.prototype, "hasFileError", null);
    __decorate([
        action
    ], MessageStore.prototype, "getMessages", null);
    __decorate([
        action
    ], MessageStore.prototype, "sendMessage", null);
    __decorate([
        action
    ], MessageStore.prototype, "selectFile", null);
    __decorate([
        action
    ], MessageStore.prototype, "deleteFile", null);
    __decorate([
        action
    ], MessageStore.prototype, "validateFileExtension", null);
    __decorate([
        action
    ], MessageStore.prototype, "validateFileSize", null);
    __decorate([
        action
    ], MessageStore.prototype, "validateFile", null);
    __decorate([
        action
    ], MessageStore.prototype, "uploadFile", null);
    __decorate([
        action
    ], MessageStore.prototype, "setLastReadMessage", null);
    __decorate([
        action
    ], MessageStore.prototype, "setFileError", null);
    __decorate([
        action
    ], MessageStore.prototype, "clearFileError", null);
    __decorate([
        computed
    ], MessageStore.prototype, "getErrorTitle", null);
    return MessageStore;
}());
export { MessageStore };
